import { useState } from 'react';

const WhyjointheBootcamp = () => {
  const [steps] = useState([
    {
      id: 1,
      icon: '🛠️',
      title: '01. Apprentissage par projets',
      description: 'Développez des bases solides en travaillant sur des projets concrets'
    },
    {
      id: 2,
      icon: '🎓',
      title: '02. Coaching',
      description: 'Apprenez auprès d\'experts du secteur qui passeront du temps avec vous.'
    },
    {
      id: 3,
      icon: '🌍',
      title: '03. Insertion professionnelle',
      description: 'Bénéficiez d\'un accompagnement à l\'emploi et d\'un coaching personnalisé'
    }
  ]);

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-dark-1 transition-colors duration-300">
      <div className="container mx-auto px-14 md:px-4">
        <div className="flex justify-center text-center mb-16">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-title font-bold text-white mb-4">
              Pourquoi rejoindre le Bootcamp ?
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div 
              key={step.id}
              className="group bg-dark-1 hover:bg-white rounded-xl px-8 py-24 cursor-pointer border border-gray-400"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 flex items-center justify-center rounded-full mb-6 text-4xl">
                  {step.icon}
                </div>
                <h3 className="text-2xl font-semibold text-white group-hover:text-dark-1 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-normal group-hover:text-dark-1">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyjointheBootcamp;